var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventticket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 1.8335V5.50016M7.33333 1.8335V5.50016",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 3.6665H10.0833C6.62636 3.6665 4.89789 3.6665 3.82394 4.74044C2.75 5.81439 2.75 7.54287 2.75 10.9998V12.8332C2.75 16.2901 2.75 18.0187 3.82394 19.0925C4.89789 20.1665 6.62636 20.1665 10.0833 20.1665H11.9167C15.3736 20.1665 17.1022 20.1665 18.176 19.0925C19.25 18.0187 19.25 16.2901 19.25 12.8332V10.9998C19.25 7.54287 19.25 5.81439 18.176 4.74044C17.1022 3.6665 15.3736 3.6665 11.9167 3.6665Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.1665H19.25",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 12.8335H14.6667M7.33333 12.8335H7.34156M11.9167 16.5002H7.33333M14.6667 16.5002H14.6584",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventticket);
export default __webpack_public_path__ + "static/media/eventticket.0ea5bdae101d31d42d4b77e6f5e822af.svg";
export { ForwardRef as ReactComponent };